import React, { FC, useCallback } from 'react';
import classNames from 'classnames';
import { IconButtonWrapper } from 'components/ui';
import styles from './BasicModal.module.scss';
import Backdrop, { IBackdrop } from '../Backdrop/Backdrop';

export interface IBasicModal extends IBackdrop {
  hasCloseButton?: boolean;
}

const BasicModal: FC<IBasicModal> = (props) => {
  const { open, onClose = () => {}, hasCloseButton, className, children } = props;
  const rootClassName = classNames(styles.root, className);

  const handleCloseModal = useCallback(() => {
    onClose();
  }, [onClose]);

  const handleDialogClick = useCallback((e) => {
    e.stopPropagation();
  }, []);

  return (
    <Backdrop open={open} onClose={handleCloseModal}>
      <div className={rootClassName} onMouseDown={handleDialogClick} role='presentation'>
        {hasCloseButton && (
          <IconButtonWrapper
            className={styles.buttonClose}
            onClick={handleCloseModal}
            icon='times'
          />
        )}
        {children}
      </div>
    </Backdrop>
  );
};

export default BasicModal;
